import React from 'react';
import { ConfirmModal } from '@/app/components/ConfirmModal';
import TrashIcon from '/public/icons/trash.svg';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
}

export const RemovePassengerModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isPending,
}) => {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      panelClassName="gap-7.5"
      title="Delete passenger?"
      description="This will remove the passenger and any associated preferences. This can’t be undone."
      confirmLabel={isPending ? 'Deleting...' : 'Delete'}
      confirmIcon={<TrashIcon className="w-4 h-4" />}
      isPending={isPending}
    />
  );
};
